import { type CancellationReason } from '@etiquetachef/types';

const D = 24 * 60 * 60 * 1000;

export type ReasonSuggestionInput = {
  lifetimeDays: number | null;
  labelsLast30d: number | null;
  billingFailedAtMs: number | null;
  suspendedAtMs: number;
};

/**
 * Heurística simples para sugerir um motivo de cancelamento ao
 * super-admin antes de ele categorizar manualmente.
 *
 * Regras (ordem de prioridade):
 *   1. PAYMENT_FAILED se billingFailedAt está nos 14 dias antes da
 *      suspensão.
 *   2. INACTIVITY se ≤1 etiqueta nos últimos 30d E lifetime > 30d.
 *   3. UNKNOWN caso contrário (super-admin pode escolher
 *      USER_REQUEST manualmente).
 */
export function suggestReason(input: ReasonSuggestionInput): CancellationReason {
  const { lifetimeDays, labelsLast30d, billingFailedAtMs, suspendedAtMs } = input;
  if (
    billingFailedAtMs !== null &&
    suspendedAtMs - billingFailedAtMs <= 14 * D &&
    suspendedAtMs - billingFailedAtMs >= 0
  ) {
    return 'PAYMENT_FAILED';
  }
  if (
    labelsLast30d !== null &&
    labelsLast30d <= 1 &&
    lifetimeDays !== null &&
    lifetimeDays > 30
  ) {
    return 'INACTIVITY';
  }
  return 'UNKNOWN';
}
